export default "__VITE_ASSET__CFVxIrIs__"